import BankSidebar from '@monetr/interface/components/Layout/BankSidebar';

export default function Sidebar(): JSX.Element {
  // const isMobile = useIsMobile();
  // if (isMobile) {
  //   return <MobileSidebar />;
  // }

  return <BankSidebar />;
}
